import Component from '../abstracts/Component';
import 'jquery-jcreate';

export default class AnimateComponent extends Component {
  get SELECTORS() {
    return {
      main: '[data-animate="true"]',
    };
  }

  constructor() {
    super();
  }

  togglerAnimation(entries) {
    const animatedClass = 'animated';
    for (let item of entries) {
      if (item.isIntersecting) {
        item.target.classList.add(animatedClass);
      }
    }
  }
  initAnimation() {
    let animatedEls = document.querySelectorAll(this.SELECTORS.main);
    const observer = new IntersectionObserver(this.togglerAnimation, { threshold: 0.3 });
    for (let item of animatedEls) {
      observer.observe(item);
    }
    $(document).on('create', this.SELECTORS.main, { ctx: this }, function(event) {
      const observer = new IntersectionObserver(
        event.data.ctx.togglerAnimation,
        { threshold: 0.3 }
      );
      observer.observe(event.currentTarget);
    });
  }
  render() {
    this.log('Rendering...');
    this.initAnimation();
  }
}
